import { c as _c } from "react/compiler-runtime";
import { FieldController } from '@module/mdrt-org/shared/components/field-controller/field-controller';
import { MAX_PRESS_RELEASE_TEXT_AREA_LENGTH } from '@module/mdrt-org/shared/utils/constants/inputs-constants';
import { FormTextarea } from '@shared/ui-components/form-textarea/form-textarea';
import styles from '@module/mdrt-org/dashboard/dashboard-page-content/components/pdf-modal-wrapper/press-release-pdf-modal/press-release-pdf-modal.module.scss';
type PersonalAnecdoteSectionProps = {
  cmsContent: {
    personalAnecdoteDescription: string;
    personalAnecdoteLabel: string;
  };
  containerClass: string;
  setActiveField: (field: string) => void;
};
export const PersonalAnecdoteSection = t0 => {
  const $ = _c(17);
  const {
    cmsContent,
    containerClass,
    setActiveField
  } = t0;
  const t1 = styles[`${containerClass}__personal-anecdote-block`];
  const t2 = styles[`${containerClass}__form-section-heading`];
  let t3;
  if ($[0] !== cmsContent.personalAnecdoteLabel) {
    t3 = <h2 className={styles["section-title"]}>{cmsContent.personalAnecdoteLabel}</h2>;
    $[0] = cmsContent.personalAnecdoteLabel;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== cmsContent.personalAnecdoteDescription) {
    t4 = <p className={styles["section-description"]}>{cmsContent.personalAnecdoteDescription}</p>;
    $[2] = cmsContent.personalAnecdoteDescription;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== setActiveField) {
    t6 = <FormTextarea onFocus={() => setActiveField("AboutProfessionalExperience")} />;
    $[8] = setActiveField;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== cmsContent.personalAnecdoteLabel || $[11] !== t6) {
    t7 = <FieldController displayMaxLengthCounter={true} label={cmsContent.personalAnecdoteLabel} maxLength={MAX_PRESS_RELEASE_TEXT_AREA_LENGTH} name="personalAnecdote">{t6}</FieldController>;
    $[10] = cmsContent.personalAnecdoteLabel;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t1 || $[14] !== t5 || $[15] !== t7) {
    t8 = <section className={t1}>{t5}{t7}</section>;
    $[13] = t1;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};